const PET_SIZE_ORDER = ['tiny', 'small', 'medium', 'large', 'huge', 'all'];

export function petSizeSortRank(petSize: string | null | undefined): number {
  const rank = PET_SIZE_ORDER.indexOf(petSize?.toLowerCase() ?? '');
  return rank === -1 ? PET_SIZE_ORDER.length : rank;
}
